'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AnalyticsService = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = require('../webComponents/utils');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _utils.getLog)('[AnalyticsService]');

var AnalyticsService = exports.AnalyticsService = function () {
    function AnalyticsService(Analytics, $q, $timeout, urlService, discountService) {
        _classCallCheck(this, AnalyticsService);

        this.analytics = Analytics;
        this.$q = $q;
        this.$timeout = $timeout;
        this.urlService = urlService;
        this.discountService = discountService;
    }

    _createClass(AnalyticsService, [{
        key: 'analyticsInitProduct',
        value: function analyticsInitProduct(product) {
            var Product = product.Product;
            this.analytics.addImpression(Product.DestinationInfo.DestinationCode, Product.DestinationInfo.DestinationName, '', '', '', '', '', Product.Price);
            this.analytics.trackDetail();
            this.analytics.pageView();
        }
    }, {
        key: 'analyticsTrackCheckout',
        value: function analyticsTrackCheckout(checkout, product) {
            var Product = product.Product;
            this.analytics.addProduct(Product.DestinationInfo.DestinationCode, Product.DestinationInfo.DestinationName, '', '', '', Product.Price, 1, '', '');
            this.analytics.trackCheckout(checkout, '');
            this.analytics.pageView();
        }
    }, {
        key: 'analyticsTrackCart',
        value: function analyticsTrackCart(product) {
            var Product = product.Product;
            this.analytics.addProduct(Product.DestinationInfo.DestinationCode, Product.DestinationInfo.DestinationName, '', '', '', Product.Price, 1, '', '');
            this.analytics.trackCart('add', 'Product list'); // Sends click event so pageView is not needed.
        }
    }, {
        key: 'analyticsReturnFromBank',
        value: function analyticsReturnFromBank(Product, BookingNumber) {
            this.analytics.addProduct(Product.DestinationInfo.DestinationCode, Product.DestinationInfo.DestinationName, '', '', '', Product.Price, 1, '', '');
            this.analytics.trackTransaction(BookingNumber, 'Winres Verkkokauppa 2.0', '', '', '', '', '', 5, '');
            this.analytics.pageView();
        }
    }, {
        key: 'initWatches',
        value: function initWatches(winresReservationContext) {
            var _this = this;

            this.winresReservationContext = winresReservationContext;
            this.contextScope = winresReservationContext.$scope;
            this.data = winresReservationContext.context;

            // Assuming url with params is kohdesivu
            if (this.urlService.isKohdeSivu()) {
                // Reset analytics only once event list
                this.gaSent = [];

                // Departure change
                this.getDeparture(false).then(function (departure) {
                    if (departure != null) {
                        var departureInfo = _this.getDepartureInfo(departure);
                        if (_this.oldDeparture && departureInfo != _this.oldDeparture) {
                            _this.initWatches(scope, context);
                        }
                        _this.oldDeparture = departureInfo;
                    }
                });

                // Product
                // Note: this will get any first product
                this.getProduct(true).then(function (product) {
                    _this.initProduct(product);
                });

                // Customer
                this.getCustomer(true).then(function (customer) {
                    _this.initCustomer(customer);
                });

                this.getCustomer(true).then(function (customer) {
                    _this.initCustomer(customer);
                });
            }
        }
    }, {
        key: 'getDepartureInfo',
        value: function getDepartureInfo(departure) {
            return departure.DestinationCode + departure.ArrivalDate + departure.ArrivalDate2 + departure.DepartureDate + departure.DepartureDate2;
        }
    }, {
        key: 'fetch',
        value: function fetch(watch, cancel) {
            var _this2 = this;

            return this.$q(function (resolve) {
                var w = _this2.contextScope.$watch(watch, function (result) {
                    if (result) {
                        // Cancel watch
                        if (cancel) {
                            w();
                        }
                        resolve(result);
                    }
                });
            });
        }
    }, {
        key: 'fetchCollection',
        value: function fetchCollection(watch, cancel) {
            var _this3 = this;

            return this.$q(function (resolve) {
                var w = _this3.contextScope.$watchCollection(watch, function (result) {
                    if (result) {
                        // Cancel watch
                        if (cancel) {
                            w();
                        }
                        resolve(result);
                    }
                }, true);
            });
        }
    }, {
        key: 'watchAccommodation',
        value: function watchAccommodation() {
            return _.find(this.data.Products, function (productLine) {
                return productLine.Product.DestinationInfo.Accommodation;
            });
        }
    }, {
        key: 'getDestination',
        value: function getDestination(cancel) {
            var _this4 = this;

            return this.fetch(function () {
                return _this4.data.Destination;
            }, cancel);
        }
    }, {
        key: 'getDeparture',
        value: function getDeparture(cancel) {
            var _this5 = this;

            return this.fetch(function () {
                return _this5.data.SelectedDeparture;
            }, cancel);
        }
    }, {
        key: 'getProduct',
        value: function getProduct(cancel) {
            var _this6 = this;

            return this.fetchCollection(function () {
                return _this6.watchAccommodation();
            }, cancel);
        }
    }, {
        key: 'getCustomer',
        value: function getCustomer(cancel) {
            var _this7 = this;

            return this.fetch(function () {
                return _this7.data.Customer;
            }, cancel);
        }
    }, {
        key: 'initProduct',
        value: function initProduct(product) {
            if (product) {
                this.analyticsInitProduct(product);
                this.dataLayerEvent('onAddProductToCart', product);
            }
        }
    }, {
        key: 'initCustomer',
        value: function initCustomer(customer) {
            var _this8 = this;

            if (customer) {
                var w = this.contextScope.$watch(function () {
                    return customer;
                }, function (result) {
                    if (_this8.hasCustomerInfo(customer)) {
                        _this8.analyticsEvent('trackCheckout', 1);
                        w();
                    }
                }, true);
            }
        }
    }, {
        key: 'hasCustomerInfo',
        value: function hasCustomerInfo(customer) {
            var i = 0;
            var key = void 0;

            for (key in customer) {
                if (key != 'AllowMarketing' && key != 'AllowElectronicMarketing' && key != 'DenyMarketing' && key != 'DenyElectronicMarketing' && key != 'CompanyName' && key != 'Country' && key != 'SubGroup' && customer[key]) {
                    i++;
                }
            }

            return i > 0;
        }
    }, {
        key: 'isAnalyticsEventSent',
        value: function isAnalyticsEventSent(str) {
            return _.some(this.gaSent, function (ga) {
                return ga === str;
            });
        }
    }, {
        key: 'analyticsEvent',
        value: function analyticsEvent(type, data) {
            var _this9 = this;

            if (!this.gaSent) this.gaSent = [];

            var str = type;

            if (data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) != 'object') str += data;

            // Send track event only once per product.
            if (!this.isAnalyticsEventSent(str)) {
                log('Analytics event:', type, data, str);

                try {
                    this.gaSent.push(str);
                    switch (type) {
                        case 'trackCheckout':
                            this.getProduct(true).then(function (product) {
                                _this9.analyticsTrackCheckout(data, product);
                            });

                            break;
                        case 'trackCart':
                            this.getProduct(true).then(function (product) {
                                _this9.analyticsTrackCart(product);
                            });

                            break;
                        case 'returnFromBank':
                            if (!data.Booking) {
                                var products = data.Productlines.products;
                                // We try to find the accommondation product, because that is most often the main product
                                // We need the main product because, it has the right destination
                                // If just picking first product from the list to send to google analytics
                                // ..it might be a extra service that has different destination
                                var filteredProduct = _.find(products, function (product) {
                                    return product.DestinationInfo.Accommodation === true;
                                });
                                // If no accommondation product is found, we try to pick the product that is for each passenger
                                // apparently if there is no linkingInfo it means that the product is avaintuote and for each passenger, so we use that logic
                                if (filteredProduct === undefined) {
                                    _.find(products, function (product) {
                                        return !product.LinkingInfo || product.LinkingInfo.IsForEachPassenger;
                                    });
                                }
                                // for now, if we don't find accommondation, we pick the first product
                                if (filteredProduct === undefined) {
                                    filteredProduct = data.Productlines.products[0];
                                }

                                this.analyticsReturnFromBank(filteredProduct, data.BookInfos.BookingNumber);
                            } else {
                                this.analyticsReturnFromBank(data.Booking.Productlines.products[0]);
                            }
                            break;
                    }
                } catch (error) {
                    console.error('[contextService] error when sending Google Analytics event: ', type, this.product, error);
                }
            }
        }

        // Search

    }, {
        key: 'dataLayerOnSearch',
        value: function dataLayerOnSearch(data) {
            if (!this.urlService.isKohdeSivu() && !this.isReturnFromBank()) {
                window.dataLayer.push({
                    'event': 'search',
                    'adults': data.searchCriteria.NumAdults,
                    'children': data.searchCriteria.NumChildren,
                    'toddlers': data.searchCriteria.NumInfants,
                    'region': data.selectedRegion ? data.selectedRegion.Name : 'All',
                    'start_date': data.searchCriteria.StartDate,
                    'end_date': data.searchCriteria.EndDate
                });
            }
        }

        // View accommodation

    }, {
        key: 'dataLayerOnLoadProduct',
        value: function dataLayerOnLoadProduct(data) {
            if (this.urlService.isKohdeSivu() && !this.isReturnFromBank() && !this.dataLayerProductLoad) {
                this.dataLayerProductLoad = true;
                window.dataLayer.push({
                    'id': data.DestinationInfo.DestinationCode + '|' + data.DestinationInfo.ProductCode,
                    'pagetype': 'offerdetail',
                    'value': data.Price,
                    'event': 'viewItem'
                });
            }
        }

        // Add accommodation to cart

    }, {
        key: 'dataLayerOnAddProductToCart',
        value: function dataLayerOnAddProductToCart(data) {
            // Kohdesivu and not return from bank
            if (this.urlService.isKohdeSivu() && !this.isReturnFromBank()) {
                window.dataLayer.push({
                    'id': data.Product.DestinationInfo.DestinationCode + '|' + data.Product.DestinationInfo.ProductCode,
                    'pagetype': 'cart',
                    'value': data.TotalPrice,
                    'event': 'addToCart'
                });
            }
        }

        // View shopping cart

    }, {
        key: 'dataLayerOnOpenCart',
        value: function dataLayerOnOpenCart(products) {
            // Kohdesivu and not return from bank
            if (this.urlService.isKohdeSivu() && !this.isReturnFromBank()) {
                var accommodation = void 0;
                if (products !== undefined) {
                    accommodation = _.find(products, function (productLine) {
                        return productLine.Product.DestinationInfo.Accommodation;
                    });
                }

                var firstProduct = products[0];
                var productLine = accommodation || firstProduct;

                if (firstProduct !== undefined) {
                    window.dataLayer.push({
                        'id': productLine.Product.DestinationInfo.DestinationCode + '|' + productLine.Product.DestinationInfo.ProductCode,
                        'start_date': productLine.Product.BeginDate,
                        'end_date': productLine.Product.EndDate,
                        'pagetype': 'conversionintent',
                        'value': this.data.totalPrice,
                        'event': 'viewCart'
                    });
                }
            }
        }

        // Return from bank

    }, {
        key: 'dataLayerOnReturnFromBank',
        value: function dataLayerOnReturnFromBank(data) {
            var accommodation = _.find(data.Productlines.products, function (product) {
                return product.DestinationInfo.Accommodation;
            });
            var totalPrice = data.BookInfos.TotalPrice;

            // E-commerce
            var ecommerceProducts = _.map(data.Productlines.products, function (product) {
                return {
                    'name': product.DestinationInfo.ProductName,
                    'id': product.DestinationInfo.DestinationCode + '|' + product.DestinationInfo.ProductCode,
                    'price': product.SelectedPrices[0].Price,
                    'brand': '',
                    'category': '',
                    'variant': '',
                    'quantity': product.SelectedPrices[0].Quantity,
                    'coupon': ''
                };
            });
            window.dataLayer.push({
                'ecommerce': {
                    'purchase': {
                        'actionField': {
                            'id': data.BookInfos.BookingNumber,
                            'affiliation': 'Online Store',
                            'revenue': totalPrice,
                            'tax': 0, // Should we add this?
                            'shipping': 0, // Should we add this?
                            'coupon': this.discountService.getDiscountCodeFromLocalStorage()
                        },
                        'products': ecommerceProducts
                    }
                }
            });

            // Accommodation
            window.dataLayer.push({
                'id': accommodation.DestinationInfo.DestinationCode + '|' + accommodation.DestinationInfo.ProductCode,
                'transactionId': data.BookInfos.BookingNumber, // transaktion ID
                'pagetype': 'conversion',
                'value': totalPrice,
                'event': 'purchase',
                'start_date': accommodation.BeginDate,
                'end_date': accommodation.EndDate
            });
        }
    }, {
        key: 'dataLayerEvent',
        value: function dataLayerEvent(event, data) {
            var _this10 = this;

            if (!window.dataLayer) {
                console.warn('dataLayer is', window.dataLayer, 'event', event);

                // Queue dataLayer event as code may still be being fetched
                if (!this.queue) {
                    this.$timeout(function () {
                        _this10.dataLayerEvent(event, data);
                    }, 2000);
                    this.queue = true;
                }
                return;
            }

            // log('DataLayer event:', event, data);

            switch (event) {
                case 'onSearch':
                    this.dataLayerOnSearch(data);
                    break;
                case 'onLoadProduct':
                    this.dataLayerOnLoadProduct(data);
                    break;
                case 'onAddProductToCart':
                    this.dataLayerOnAddProductToCart(data);
                    break;
                case 'onOpenCart':
                    this.dataLayerOnOpenCart(data);
                    break;
                case 'onReturnFromBank':
                    this.dataLayerOnReturnFromBank(data);
                    break;
                default:
                    break;
            }
        }
    }, {
        key: 'isReturnFromBank',
        value: function isReturnFromBank() {
            return window.location.href.indexOf('bookingSessionId') > -1;
        }
    }]);

    return AnalyticsService;
}();

AnalyticsService.$inject = ['Analytics', '$q', '$timeout', 'urlService', 'discountService'];


//////////////////
// WEBPACK FOOTER
// ./src/winresCloud/analyticsService.js
// module id = 574
// module chunks = 2